import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1395.06,960 C1560.18,960 1694.46,1094.16 1694.94,1259.04 C1694.94,1259.34 1695.02333,1259.64 1695.05111,1259.87056 L1695.06,1260 C1695.06,1425.36 1560.42,1560 1395.06,1560 C1229.7,1560 1095.06,1425.36 1095.06,1260 C1095.06,1094.64 1229.7,960 1395.06,960 Z M420.06,960 C585.42,960 720.06,1094.64 720.06,1260 C720.06,1425.36 585.42,1560 420.06,1560 C254.58,1560 120.06,1425.36 120.06,1260 C120.06,1094.64 254.58,960 420.06,960 Z M1814.94,1259.04 C1814.58,1134.24 1717.98,477.24 1714.02,450.6 C1699.26,330.6 1596.9,240 1475.82,240 L1320.06,240 L1320.06,360 L1475.82,360 C1536.3,360 1587.54,405.24 1595.1,466.68 C1610.1,568.56 1637.94,763.92 1660.5,937.32 C1587.9,877.44 1496.22,840 1395.06,840 C1184.1,840 1010.58,997.08 981.06,1200 L833.94,1200 C804.54,997.08 631.02,840 420.06,840 C318.78,840 227.1,877.44 154.5,937.32 C177.06,763.8 205.02,567.84 220.02,465.24 C227.46,405.24 278.7,360 339.18,360 L480.06,360 L480.06,240 L339.18,240 C218.1,240 115.74,330.6 101.22,449.28 C97.02,477.24 0.06,1137 0.06,1260 C0.06,1491.6 188.46,1680 420.06,1680 C631.02,1680 804.54,1522.92 833.94,1320 L981.06,1320 C1010.58,1522.92 1184.1,1680 1395.06,1680 C1626.66,1680 1815.06,1491.6 1815.06,1260 C1815.06,1259.76 1814.94,1259.4 1814.94,1259.04",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconStudentViewLine = /*#__PURE__*/function (_Component) {
  _inherits(IconStudentViewLine, _Component);

  var _super = _createSuper(IconStudentViewLine);

  function IconStudentViewLine() {
    _classCallCheck(this, IconStudentViewLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconStudentViewLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconStudentView",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconStudentViewLine.displayName = "IconStudentViewLine";
  return IconStudentViewLine;
}(Component);

IconStudentViewLine.glyphName = 'student-view';
IconStudentViewLine.variant = 'Line';
IconStudentViewLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconStudentViewLine;
export { IconStudentViewLine };